import eco1 from "../../images/eco/eco1.jpg";
import eco2 from "../../images/eco/eco2.jpg";
import eco3 from "../../images/eco/eco3.jpg";
import eco4 from "../../images/eco/eco4.jpg";

const ecoProducts = [
  {
    image: eco1,
    name: "Menstrual-Pads",
    price: "$5.00 USD",
  },
  {
    image: eco2,
    name: "Bag-Dispenser Products",
    price: "$8.00 USD",
  },
  {
    image: eco3,
    name: "Canvas Painting ",
    price: "$4.00 USD",
  },
  {
    image: eco4,
    name: "Gifts bag",
    price: "$11.00 USD",
  },
];
export default ecoProducts;
